import React, { useEffect, useState, useRef} from 'react'
import { useHistory } from 'react-router-dom'
import api from '../components/api';
import JoditEditor from "jodit-react"
import axios from 'axios'



const NoticiaEdit = (props) => {


    // var linkAPI = 'http://172.16.1.253:3600/'
    var linkAPI = process.env.REACT_APP_API
    


    var history = useHistory()

    var [na_codigo, setNa_codigo] = useState(props.match.params.na_codigo)
    //var [editorState, setEditorState] = useState()
    var [texto, setTexto] = useState()
    var [categorias, setCategorias] = useState()
    var [categoria_id, setCategoria_Id] = useState()

    var [resumo, setResumo] = useState('')
    var [imagem, setImagem] = useState()
    var [arquivoThumb, setArquivoThumb] = useState()
    var [tags, setTags] = useState('')
    var [file, setFile] = useState()

    
    var [titulo, setTitulo] = useState()

    const editor = useRef(null)
    const [content, setContent] = useState('')

    const [config, setConfig] = useState({
        readonly: false,
        toolbar: true,
        height: 500,
        placeholder: 'Escreva aqui...',
      })

    async function carregaNoticia() {


        //console.log(na_codigo)
        await api.get(`noticia/${na_codigo}`).then((result) => {
            //console.log(result.data, '!!')
            
            setTitulo(result.data[0].na_titulo)
            setContent(result.data[0].na_texto)
            setTexto(result.data[0].na_texto)
            setCategoria_Id(result.data[0].categoria_id)
            setTags(result.data[0].tags)
            setArquivoThumb(result.data[0].thumb)
            setResumo(result.data[0].resumo)

        }).catch((err) => {
            console.log(err.response)
        })


    }


    async function carregaCategorias() {

        await api.get('categoria').then((result) => {

            //console.log(result.data)
            setCategorias(result.data.map((rs) => 
            
                <option value={rs.categoria_id}>{rs.descricao}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }

    async function salvar() {


        if (categoria_id == null || categoria_id == '') {

            window.toastr.error('<b>Categoria</b> não pode ficar em branco!')
            return false

        }

        if (titulo == '') {

            window.toastr.error('<b>Título</b> não pode ficar em branco!')
            return false

        }


        if (resumo == '') {

            window.toastr.error('<b>Resumo</b> não pode ficar em branco!')
            return false

        }

        

        /*
        var dataPost = {

            na_titulo: titulo,
            na_texto: texto,
            categoria_id: categoria_id,
        }
        */

        //console.log(dataPost)
        //return false

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {


                    //window.toastr.info('Aguarde...')

                    

                    if (!isNaN(na_codigo)) {


                        const formData = new FormData();
                        const imagefile = document.querySelector("#fileImgNot");

                        

                        // 'fileimage' é o campo que o 'multer' procura o arquivo de imagem.
                        formData.append("imagem", imagefile.files[0]);
                        formData.append("na_titulo", titulo); 
                        formData.append("categoria_id", categoria_id); 
                        formData.append("na_texto", texto); 
                        formData.append("tags", tags); 
                        formData.append("resumo", resumo); 
                        
                        //console.log(imagefile.files[0])
                        //console.log(formData)
                        //return false

                        axios.put(`${linkAPI}/noticia/${na_codigo}`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'x-access-token': '!nf0$@ud#2',
                        }
                        }).then(response => {

                            

                            var img = response.data.imagem
                            if (img != '' || img != null) { setArquivoThumb(img) }

                            console.log(response.data)
                            
                            
                            setFile('')

                            window.toastr.success('Salvo com sucesso!')



                        }).catch((err) => {

                            console.log(err.response)

                        })
                        

                        /*

                        api.put(`noticia/${na_codigo}`, dataPost).then((response) => {

                            window.toastr.success('Salvo com sucesso!')

                        }).catch((err) => {
                            console.log(err.response)
                        })

                        */


                    } else {

                        /*

                        api.post('noticia', dataPost).then((response) => {

                            console.log(response.data)
                            window.toastr.success('Salvo com sucesso!')
                            var data = response.data[0]
                            setNa_codigo(data.na_codigo)

                        }).catch((err) => {

                            console.log(err.response)

                        })

                        */

                        const formData = new FormData();
                        const imagefile = document.querySelector("#fileImgNot");

                        

                        // 'fileimage' é o campo que o 'multer' procura o arquivo de imagem.
                        formData.append("imagem", imagefile.files[0]);
                        formData.append("na_titulo", titulo); 
                        formData.append("categoria_id", categoria_id); 
                        formData.append("na_texto", texto); 
                        formData.append("tags", tags); 
                        formData.append("resumo", resumo); 
                        
                        //console.log('altera')
                        //return false

                        axios.post(`${linkAPI}/noticia`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'x-access-token': '!nf0$@ud#2',
                        }
                        }).then(response => {

                            var img = response.data[0].imagem
                            if (img != '' || img != null) { setArquivoThumb(img) }

                            //console.log(response.data)
                            setNa_codigo(response.data[0].na_codigo)
                            
                            setFile('')

                            window.toastr.success('Salvo com sucesso!')



                        }).catch((err) => {

                            console.log(err.response)

                        })

                    }
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    function apagar() {


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {


                    //window.toastr.info('Aguarde...')

                    
                        api.delete(`noticia/${na_codigo}`).then((response) => {

                            console.log(response.data)
                            window.toastr.success('Apagado com sucesso!')
                            history.push('/Noticias')

                        }).catch((err) => {

                            console.log(err.response)

                        })

                   
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    async function verificaPermissao() {


        if (sessionStorage.getItem('permNoticias') != 'true') {

            history.push('/')

        }


    }


    useEffect(() => {

        if (na_codigo != 'Nova') {

            carregaNoticia()

        }

        verificaPermissao()
        carregaCategorias()
        
    }, [])


    return (
            
        <div>
            <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-pin'></i>
                </div>
                <div class='header-title'>
                    <h1>Notícias</h1>
                    <small>Administração</small>
                    
                </div>
            </div>


            <div className="row">

                <div class="col-md-12">
                    <div class="form-group">
                        <label>Título</label>
                        <input type="text" class="form-control" placeholder="" value={titulo} onChange={event => setTitulo(event.target.value)} />
                                        
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group">
                        <label>Categoria</label>
                        <select class="form-control" value={categoria_id} onChange={event => setCategoria_Id(event.target.value)} >
                            <option value="">[Selecione]</option>
                            {categorias}
                        </select>
                                        
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group">
                        <label>Tags</label>
                        <textarea type="text" class="form-control" placeholder="" rows="2" value={tags} onChange={event => setTags(event.target.value)} maxlength="500" />
                                        
                    </div>
                </div>


                <div class="col-md-12">
                    <div class="form-group">
                        <label>Resumo</label>
                        <textarea type="text" class="form-control" placeholder="" rows="4" value={resumo} onChange={event => setResumo(event.target.value)} maxlength="4000" />
                                        
                    </div>
                </div>

                <div class="col-md-12">

                <JoditEditor 
                    ref={editor}
                    value={content}
                    config={config}
                    tabIndex={1} // tabIndex of textarea
                    onBlur={newContent => setTexto(newContent)} // preferred to use only this option to update the content for performance reasons
                    onChange={newContent => {}}
                />

                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label>Arquivo Thumb</label>
                        <input type="text" className="form-control" placeholder="" value={arquivoThumb} readOnly style={{cursor: 'pointer' }} onClick={() => window.open(`${linkAPI}/uploads/noticia/${arquivoThumb}`)}/>
                        
                                        
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label>Arquivo Imagem</label>
                        <input type="file" class="form-control" id="fileImgNot" />
                                        
                    </div>
                </div>

                <div class="col-md-12">

                    <br/>
                                    
                    <button type="button" class="btn btn-info" onClick={() => history.push('/Noticias')}>Voltar</button>&nbsp;
                    <button type="button" class="btn btn-danger" style={{ display: !isNaN(na_codigo) ? 'table-row' : 'none'}} onClick={() => apagar()}>Apagar</button>&nbsp;
                    <button type="button" class="btn btn-primary" onClick={() => salvar()}>Salvar</button>
                </div>

            </div>


        </div>

    )

}

export default NoticiaEdit